import AuthExperience from '../sections/auth/AuthExperience';

export default function Login() {
  return <AuthExperience mode="login" />;
}
